<div class="goal-create-weighting-container" [class.parent-dropdown-closed]="!parentDropdownOpen">
  <ng-container *ngIf="parentDropdownOpen; else templateDisplayValues">
    <div class="p-15">
        <div class="card card-yellow alignment-description-text">
          <div class="content">
            <span class="fal fa-fw fa-info-circle m-right-5"></span>
            <!-- <span translate>{{eGoalsMessages.GOAL_CREATE_WEIGHTING_EXPLANATION}}</span> -->
             <a target="_blank" href="./goals">View goals in context</a>
          </div>
        </div>
      <div class="frankli-form-group-placeholder-shown frankli-form-group-filled">
        <input id="current-value" class="form-control" type="number" [min]="0" inputmode="numeric"
          autocomplete="off" [formControl]="controlWeightings"
          [placeholder]="eGoalsMessages.CURRENT_VALUE | translate" />
      </div>

    </div>
  </ng-container>
  <ng-template #templateDisplayValues>
    <ng-container *ngIf="controlWeight.value">
      <div class="p-15">
        <span>{{ controlWeight.value }}</span>
      </div>
    </ng-container>
  </ng-template>
</div>